"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _filterEmptyData = require("./filterEmptyData");
Object.keys(_filterEmptyData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _filterEmptyData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _filterEmptyData[key];
    }
  });
});
var _getPlaceholderSize = require("./getPlaceholderSize");
Object.keys(_getPlaceholderSize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getPlaceholderSize[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getPlaceholderSize[key];
    }
  });
});
